<template>
  <div class="flex align-middle">
    <label
      class="flex mb-0 mt-2 font-normal cursor-pointer ds-text-base"
      :class="option.disabled ? 'cursor-not-allowed text-gray-500' : 'text-gray-900'"
      v-html="option.label"
    />
    <div class="needs-badge flex flex-col justify-center mt-2 ml-2">
      <div class="w-full p-0 m-0 text-white ds-text-2xs">
        <Badge :color="badgeColor" :count="option.needsCount" :icon="icon" :text="badgeText" :cap="999"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Badge } from '@sportsrecruits/playbook'
import upperFirst from 'lodash/upperFirst';

export default {
  name: "AccordionLabelWithBadge",
  components: {
    Badge
  },
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  computed: {
    isHeaderOption() {
        return !((this.option.needType === 'all' && this.option.depth === 3) || (['full', 'potential'].includes(this.option.needType) && this.option.depth === 2))
    },
    icon() {
        if(this.option.needType === 'full')
            return 'checkmark-circle';
    
        if(this.option.needType === 'potential')
            return 'sr-v2-exclamation-circle';

        return '';
    },
    badgeColor() {
        if(!this.option.needsCount) return 'gray';

        return ({
        full: 'green',
        potential: 'orange',
        all: 'blue'
        })[this.option.needType];
    },
    badgeText() {
        if(!this.isHeaderOption) return '';

        const capitalizedType = upperFirst(this.option.needType);
        const isPlural  = this.option.needsCount !== 1;
        return this.isHeaderOption && ['full', 'potential'].includes(this.option.needType) ? `${capitalizedType} Match${isPlural ? 'es' : ''}` : `Roster Need${isPlural ? 's':''}`;
    }
  }
}
</script>